import * as actionTypes from "./actionTypes";

export const reprocessData = (payload) => ({
  type: actionTypes.REPROCESS_DATA,
  payload,
});

export const reprocessDataSuccess = (payload) => ({
  type: actionTypes.REPROCESS_DATA_SUCCESS,
  payload,
});

export const reprocessDataFailed = (payload) => ({
  type: actionTypes.REPROCESS_DATA_FAILED,
  payload,
});

export const deleteUserScreenshots = (payload) => ({
  type: actionTypes.DELETE_USER_SCREENSHOTS,
  payload,
});

export const deleteUserScreenshotsSuccess = (payload) => ({
  type: actionTypes.DELETE_USER_SCREENSHOTS_SUCCESS,
  payload,
});

export const deleteUserScreenshotsFailed = (payload) => ({
  type: actionTypes.DELETE_USER_SCREENSHOTS_FAILED,
  payload,
});

export const resetMaintenanceStuff = (payload) => ({
  type: actionTypes.RESET_MAINTENANCE_STUFF,
  payload,
});

export const sendEmailReport = (payload) => ({
  type: actionTypes.SEND_EMAIL_REPORT,
  payload,
});

export const sendEmailReportSuccess = (payload) => ({
  type: actionTypes.SEND_EMAIL_REPORT_SUCCESS,
  payload,
});

export const sendEmailReportFailed = (payload) => ({
  type: actionTypes.SEND_EMAIL_REPORT_FAILED,
  payload,
});
